<template>
  <v-app class="overflow-hidden">
    <v-navigation-drawer
      v-model="drawer"
      app
      :bottom="isMobile"
      class="sidebar_auth"
      clipped
      :style="`margin-top: ${$vuetify.application.top}px`"
      temporary
    >
      <siderbar @update:isShowSidebar="isShowSidebar = $event"></siderbar>
    </v-navigation-drawer>
    <navbar
      app
      class="header_auth"
      clipped-left
      :hide-header-aside="!isShowSidebar"
    >
      <template v-if="isShowSidebar" #menu-sidebar>
        <v-app-bar-nav-icon
          @click.stop="currentDrawer = !currentDrawer"
          @mouseover="!currentDrawer ? (currentDrawer = true) : null"
        >
        </v-app-bar-nav-icon>
      </template>
    </navbar>
    <v-main class="overflow-auto">
      <v-row :class="{ 'full-height': !isMobile }" no-gutters>
        <v-col class="full-height" cols="12" lg="2" md="4" sm="3">
          <v-sheet
            class="full-height full-width d-flex flex-column"
            color="#F7F7F6"
            height="100%"
          >
            <AvatarSidebar />
            <div class="py-2">
              <v-subheader>Tài khoản của tôi</v-subheader>
              <v-list-item
                v-for="(item, key) in itemsSidebar"
                :key="key"
                active-class="profile-sidebar-item-active"
                class="profile-sidebar-item"
                dense
                exact
                :to="item.router"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <trans-field transable :value="item"></trans-field>
                </v-list-item-title>
              </v-list-item>
            </div>
          </v-sheet>
        </v-col>
        <v-col cols="12" lg="8" md="8" sm="9">
          <loading-container location="profile-layout">
            <router-view />
            <slot />
          </loading-container>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import AvatarSidebar from './avatar-sidebar.vue'
import { getVersion } from '@constant'
import navbar from '../navbar.vue'
import siderbar from '../siderbar.vue'
import { mapGetters } from 'vuex'
export default {
  components: { navbar, siderbar, AvatarSidebar },
  data: () => ({
    drawer: false,
    isShowSidebar: false,
    model: {},
    itemsSidebar: [
      {
        icon: 'mdi-clipboard-text',
        text: 'Hồ sơ',
        router: {
          name: 'profile',
        },
      },
      {
        icon: 'mdi-pencil',
        text: 'Đổi mật khẩu',
        router: {
          name: 'profile.password',
        },
      },
    ],
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    bindDrawer() {
      return {}
    },
    version() {
      return getVersion()
    },
    currentDrawer: {
      get() {
        return this.drawer
      },
      set(value) {
        this.drawer = value
      },
    },
  },
  mounted() {
    this.drawer = false
  },
  watch: {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.header_auth {
  background: #ffffff !important;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 8%) !important;
}
.sidebar_auth {
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
}
.profile-sidebar-item-active {
  &::before {
    opacity: 0;
  }
  background: #ffffff;
  border-left-color: var(--v-primary-base) !important;
  color: #3d4d5b;
}
.theme--light .v-list-item.profile-sidebar-item {
  border-left: 4px solid transparent;
  max-width: 270px;
}
.theme--light
  .v-list-item.profile-sidebar-item:not(.profile-sidebar-item-active) {
  color: #787878 !important;
}
</style>
